@if (loading()) {
  <cue-loading />
} @else if (news()) {
  <div class="wrapper">
    <div class="news-inner">
      <div class="news-header">
        <div class="text">
          <div class="news-title">
            <assist-layout-title [title]="news().title | localizedString" />
            <h1>{{ news().title | localizedString }}</h1>
            <div [style.background-color]="news().color" class="divider"></div>
            <p class="description">
              {{ news().shortDescription | localizedString }}
            </p>
          </div>
          <div class="date-time-wrapper">
            @if (news().from) {
              <p class="from">
                {{ news().from | dateFormat }}
              </p>
            }
          </div>
        </div>
        <div class="image">
          <img [src]="news().imageUrl | imageWidth: 300" class="news-main-image" />
          <!--<img class="news-main-image" src="https://aluprof.eu/app/default/files-module/local/images/aluprof_scena02-scianki_dzialowe_view01-fix_p_45-office_.jpg">-->
        </div>
      </div>
      @if (news()?.hasDetail) {
        <div class="news-body-wrapper">
          <div [innerHTML]="news().body | localizedString" class="news-body"></div>
        </div>
      }
    </div>
  </div>
} @else {
  Could not load news.
}
